module.exports = __webpack_public_path__ + "img/file-drop-image.fd4a2d11.svg";